import React from 'react';
import { useTranslation } from 'react-i18next';
import { RadioLabel, CurrencyInput, Section, Input, Form } from '@weezevent/nacre';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import Style from './selectTypeDiscount.module.css';
import RateGrid from './rateGrid';
import { useSegment } from '../../../components/tracking/trackingProvider';
export default function SelectTypeDiscount({ discountForm, onDiscounts, event, ratesAndGroups, openAllAccorindon, discountId }) {
    const { t } = useTranslation();
    const { track } = useSegment();
    const locale = i18n.language;
    const rightLabel = { rightLabel: '%' };

    const disabled = React.useMemo(() => {
        return Boolean(discountId && discountForm.usage > 0);
    }, [discountForm, discountId]);

    return (
        <div className={Style['select-type-discount']}>
            <RadioLabel
                name="type-of-discount"
                className={Style['input-radio']}
                value="amount"
                inline
                bordered
                active={discountForm.type === 'amount'}
                checked={discountForm.type === 'amount'}
                disabled={disabled}
                label={t('ticket.discountForm.type.amount')}
                onClick={() => {
                    track('ACTION > SELECT DISCOUNT TYPE', { 'Page Title': 'CREATE DISCOUNT', Application: 'WeezTicket nBO', 'Discount info': 'Fixed' });
                    onDiscounts('type', 'amount');
                    onDiscounts('value', '');
                    onDiscounts('rate', {});
                }}
            />
            <RadioLabel
                name="type-of-discount"
                className={Style['input-radio']}
                value="percentage"
                inline
                bordered
                disabled={disabled}
                active={discountForm.type === 'percentage'}
                checked={discountForm.type === 'percentage'}
                label={t('ticket.discountForm.type.percent')}
                onClick={() => {
                    track('ACTION > SELECT DISCOUNT TYPE', { 'Page Title': 'CREATE DISCOUNT', Application: 'WeezTicket nBO', 'Discount info': 'Percentage' });
                    onDiscounts('type', 'percentage');
                    onDiscounts('value', '');
                    onDiscounts('rate', {});
                }}
            />
            <RadioLabel
                name="type-of-discount"
                className={Style['input-radio']}
                value="grid"
                inline
                bordered
                disabled={disabled}
                active={discountForm.type === 'grid'}
                checked={discountForm.type === 'grid'}
                label={t('ticket.discountForm.type.grid')}
                onClick={() => {
                    track('ACTION > SELECT DISCOUNT TYPE', { 'Page Title': 'CREATE DISCOUNT', Application: 'WeezTicket nBO', 'Discount info': 'Template' });
                    onDiscounts('type', 'grid');
                    onDiscounts('value', '');
                    onDiscounts('rate', {});
                    onDiscounts('ratesToSelect', []);
                }}
            />
            <>
                {discountForm.type === 'amount' && (
                    <Section>
                        <Form.Label label={t('ticket.discountForm.input_label.amount')} />
                        <CurrencyInput
                            value={discountForm.value}
                            currency={event?.currency}
                            locale={locale}
                            onChange={event => {
                                onDiscounts('value', event.value);
                            }}
                        />
                    </Section>
                )}
                {discountForm.type === 'percentage' && (
                    <Section>
                        <Form.Label label={t('ticket.discountForm.input_label.percent')} />
                        <Input
                            className={Style['percent-input']}
                            value={discountForm.value}
                            type="number"
                            onChange={event => onDiscounts('value', Number(event.target.value) > 100 ? 100 : event.target.value)}
                            {...rightLabel}
                        />
                    </Section>
                )}
                {discountForm.type === 'grid' && (
                    <RateGrid event={event} ratesAndGroups={ratesAndGroups} discountForm={discountForm} onDiscounts={onDiscounts} openAllAccorindon={openAllAccorindon} />
                )}
            </>
        </div>
    );
}

SelectTypeDiscount.propTypes = {
    discountForm: PropTypes.object.isRequired,
    onDiscounts: PropTypes.func.isRequired,
    event: PropTypes.object.isRequired,
    openAllAccorindon: PropTypes.bool,
    discountId: PropTypes.number
};
